import './index.scss';

document.addEventListener('DOMContentLoaded', () => {
  // menu
  const siteHeader = document.getElementById('site-header');

  for (const button of document.getElementsByClassName('header-menu-btn')) {
    button.addEventListener('click', () => {
      siteHeader.classList.toggle('menu-open');
    });
  };

  const mobileMenuOverlay = document.getElementById('mobile-nav');
  mobileMenuOverlay.addEventListener('click', function(e) {
      if (e.target === mobileMenuOverlay) {
          siteHeader.classList.remove('menu-open');
      }
  });

  // lang picker
  const picker = document.querySelector('.lang-picker');
  const pickerButton = picker.querySelector('.lang-picker-toggle');

  pickerButton.addEventListener("click", (e) => {
    e.stopPropagation();
    picker.classList.toggle("open");
  });

  document.addEventListener("click", () => {
    picker.classList.remove("open");
  });

  // page header banner
  // const headerContent = document.getElementById('header-content');
  // const headerContentImage = document.getElementById('header-content-image');
  // const headerContentText = document.getElementById('header-content-text');

  // if (headerContent && headerContentImage) {
  //   headerContent.appendChild(headerContentImage);
  // }

  // if (headerContent && headerContentText) {
  //   headerContent.appendChild(headerContentText);
  //   document.body.classList.add('has-header-content');
  // }
});

import './js/ifus';
import './js/infinite-scroll';